module.exports = __webpack_public_path__ + "img/52002736_L.735646a3.png";